import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar";
import Modal from "../../components/Modal";
import api from "../../services/api";

const fmt = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const MESES = ["Janeiro","Fevereiro","Marco","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const DIAS_SEMANA = ["Dom","Seg","Ter","Qua","Qui","Sex","Sab"];
const STATUS_PAGAR   = {PENDENTE:{l:"Pendente",cor:"var(--z-warning-text)"},PAGO:{l:"Pago",cor:"var(--z-success-text)"},VENCIDO:{l:"Vencido",cor:"var(--z-danger-text)"},CANCELADO:{l:"Cancelado",cor:"var(--z-text-muted)"}};
const STATUS_RECEBER = {PENDENTE:{l:"Pendente",cor:"var(--z-warning-text)"},RECEBIDO:{l:"Recebido",cor:"var(--z-success-text)"},VENCIDO:{l:"Vencido",cor:"var(--z-danger-text)"},CANCELADO:{l:"Cancelado",cor:"var(--z-text-muted)"}};
const CATS_PAGAR   = [{v:"FORNECEDOR",l:"Fornecedor"},{v:"FUNCIONARIO",l:"Funcionario"},{v:"SERVICO",l:"Servico"},{v:"ALUGUEL",l:"Aluguel"},{v:"ENERGIA",l:"Energia"},{v:"OUTROS",l:"Outros"}];
const CATS_RECEBER = [{v:"VENDA",l:"Venda"},{v:"SERVICO",l:"Servico"},{v:"OUTROS",l:"Outros"}];
const hoje = new Date().toISOString().slice(0,10);
const mesAtual = new Date().getMonth()+1;
const anoAtual = new Date().getFullYear();

function CalendarioFinanceiro({contasPagar, contasReceber}) {
  const agora = new Date();
  const [mesV, setMesV] = useState(agora.getMonth());
  const [anoV, setAnoV] = useState(agora.getFullYear());
  const primeiroDia = new Date(anoV, mesV, 1).getDay();
  const diasNoMes   = new Date(anoV, mesV+1, 0).getDate();
  const eventosNoDia = (dia) => {
    const d = `${anoV}-${String(mesV+1).padStart(2,"0")}-${String(dia).padStart(2,"0")}`;
    return {
      pagar:   contasPagar.filter(c=>c.data_vencimento===d&&["PENDENTE","VENCIDO"].includes(c.status)),
      receber: contasReceber.filter(c=>c.data_vencimento===d&&["PENDENTE","VENCIDO"].includes(c.status)),
    };
  };
  const celulas = [];
  for(let i=0;i<primeiroDia;i++) celulas.push(null);
  for(let i=1;i<=diasNoMes;i++) celulas.push(i);
  return(
    <div style={{background:"#fff",borderRadius:8,padding:16,boxShadow:"0 1px 4px rgba(0,0,0,0.06)",marginBottom:16}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mesV===0){setMesV(11);setAnoV(a=>a-1);}else setMesV(m=>m-1);}}>‹</button>
        <strong style={{fontSize:15}}>{MESES[mesV]} {anoV}</strong>
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mesV===11){setMesV(0);setAnoV(a=>a+1);}else setMesV(m=>m+1);}}>›</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4}}>
        {DIAS_SEMANA.map(d=><div key={d} style={{textAlign:"center",fontSize:11,fontWeight:600,color:"var(--z-text-muted)",padding:"4px 0"}}>{d}</div>)}
        {celulas.map((dia,i)=>{
          if(!dia) return <div key={"e"+i}/>;
          const {pagar,receber}=eventosNoDia(dia);
          const isHoje=dia===agora.getDate()&&mesV===agora.getMonth()&&anoV===agora.getFullYear();
          return(
            <div key={dia} style={{minHeight:60,border:"1px solid "+(isHoje?"var(--z-blue)":"var(--z-border)"),borderRadius:6,padding:"4px 6px",background:isHoje?"#eff6ff":"#fff"}}>
              <div style={{fontSize:12,fontWeight:isHoje?700:400,color:isHoje?"var(--z-blue)":"var(--z-text-secondary)",marginBottom:2}}>{dia}</div>
              {pagar.map(c=>(
                <div key={"p"+c.id} title={c.descricao} style={{fontSize:10,background:"#fee2e2",color:"#dc2626",borderRadius:3,padding:"1px 4px",marginBottom:2,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                  ↓ R$ {fmt(c.valor)}
                </div>
              ))}
              {receber.map(c=>(
                <div key={"r"+c.id} title={c.descricao} style={{fontSize:10,background:"#dcfce7",color:"#16a34a",borderRadius:3,padding:"1px 4px",marginBottom:2,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                  ↑ R$ {fmt(c.valor)}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div style={{display:"flex",gap:16,marginTop:8,fontSize:11}}>
        <span><span style={{display:"inline-block",width:12,height:12,background:"#fee2e2",borderRadius:2,marginRight:4}}/> A Pagar</span>
        <span><span style={{display:"inline-block",width:12,height:12,background:"#dcfce7",borderRadius:2,marginRight:4}}/> A Receber</span>
      </div>
    </div>
  );
}

export default function Financeiro() {
  const [aba, setAba]               = useState("pagar");
  const [abaVis, setAbaVis]         = useState("lista");
  const [contasPagar, setContasPagar]     = useState([]);
  const [contasReceber, setContasReceber] = useState([]);
  const [fluxo, setFluxo]           = useState(null);
  const [clientes, setClientes]     = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [filtroStatus, setFiltroStatus] = useState("");
  const [modalForm, setModalForm]   = useState(null);
  const [form, setForm]             = useState({});
  const [salvando, setSalvando]     = useState(false);
  const [mes, setMes]               = useState(mesAtual);
  const [ano, setAno]               = useState(anoAtual);
  const [modalPagar, setModalPagar] = useState(null);
  const [dataPag, setDataPag]       = useState(hoje);

  const carregar = () => {
    setLoading(true);
    Promise.all([
      api.get("/financeiro/contas-pagar/?page_size=1000"),
      api.get("/financeiro/contas-receber/?page_size=1000"),
      api.get("/financeiro/caixa/fluxo/?mes="+mes+"&ano="+ano),
      api.get("/clientes/contatos/?page_size=1000"),
    ]).then(([cpRes,crRes,flRes,cRes])=>{
      setContasPagar(cpRes.data.results||cpRes.data);
      setContasReceber(crRes.data.results||crRes.data);
      setFluxo(flRes.data);
      const todos=cRes.data.results||cRes.data;
      setClientes(todos.filter(c=>c.tipo!=="FORNECEDOR"));
      setFornecedores(todos.filter(c=>c.tipo==="FORNECEDOR"));
    }).finally(()=>setLoading(false));
  };

  useEffect(()=>{carregar();},[mes,ano]);

  const setF=(f,v)=>setForm(prev=>({...prev,[f]:v}));

  const salvarConta=async()=>{
    setSalvando(true);
    try{
      const dados={...form};
      if(aba==="pagar"){
        if(dados.fornecedor) dados.fornecedor=parseInt(dados.fornecedor);
        if(modalForm==="novo") await api.post("/financeiro/contas-pagar/",dados);
        else await api.put("/financeiro/contas-pagar/"+dados.id+"/",dados);
      } else {
        if(dados.cliente) dados.cliente=parseInt(dados.cliente);
        if(modalForm==="novo") await api.post("/financeiro/contas-receber/",dados);
        else await api.put("/financeiro/contas-receber/"+dados.id+"/",dados);
      }
      carregar();setModalForm(null);
    }catch(e){alert("Erro ao salvar.");}
    finally{setSalvando(false);}
  };

  const confirmarPagamento=async()=>{
    if(aba==="pagar") await api.post("/financeiro/contas-pagar/"+modalPagar.id+"/pagar/",{data_pagamento:dataPag});
    else await api.post("/financeiro/contas-receber/"+modalPagar.id+"/receber/",{data_recebimento:dataPag});
    setModalPagar(null);carregar();
  };

  const excluir=async(id)=>{
    if(!window.confirm("Excluir?")) return;
    if(aba==="pagar") await api.delete("/financeiro/contas-pagar/"+id+"/");
    else await api.delete("/financeiro/contas-receber/"+id+"/");
    carregar();
  };

  const abrirNovo=()=>{
    setForm(aba==="pagar"
      ?{descricao:"",categoria:"FORNECEDOR",fornecedor:"",valor:"",data_vencimento:"",status:"PENDENTE",observacoes:""}
      :{descricao:"",categoria:"VENDA",cliente:"",valor:"",data_vencimento:"",status:"PENDENTE",observacoes:""}
    );
    setModalForm("novo");
  };

  const lista=aba==="pagar"?contasPagar:contasReceber;
  const STATUS=aba==="pagar"?STATUS_PAGAR:STATUS_RECEBER;
  const filtrada=lista.filter(c=>!filtroStatus||c.status===filtroStatus);
  const totalPendente=lista.filter(c=>c.status==="PENDENTE").reduce((s,c)=>s+parseFloat(c.valor),0);
  const totalVencido=lista.filter(c=>c.status==="VENCIDO").reduce((s,c)=>s+parseFloat(c.valor),0);

  return(
    <>
      <Topbar title="Financeiro"/>
      <div className="erp-content">
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
          {[
            {l:"A Pagar", v:contasPagar.filter(c=>["PENDENTE","VENCIDO"].includes(c.status)).reduce((s,c)=>s+parseFloat(c.valor),0), cor:"var(--z-danger-text)"},
            {l:"A Receber", v:contasReceber.filter(c=>["PENDENTE","VENCIDO"].includes(c.status)).reduce((s,c)=>s+parseFloat(c.valor),0), cor:"var(--z-blue)"},
            {l:"Entradas no Mes", v:fluxo?.entradas||0, cor:"var(--z-success-text)"},
            {l:"Saidas no Mes", v:fluxo?.saidas||0, cor:"var(--z-danger-text)"},
          ].map((card,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:8,padding:"16px",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
              <div style={{fontSize:11,color:"var(--z-text-muted)",fontWeight:600,textTransform:"uppercase",marginBottom:4}}>{card.l}</div>
              <div style={{fontSize:20,fontWeight:700,color:card.cor}}>R$ {fmt(card.v)}</div>
            </div>
          ))}
        </div>

        {fluxo&&(
          <div style={{background:"#fff",borderRadius:8,padding:"12px 16px",marginBottom:16,boxShadow:"0 1px 4px rgba(0,0,0,0.06)",display:"flex",gap:16,alignItems:"center",flexWrap:"wrap"}}>
            <span className="fs-13">Fluxo de caixa:</span>
            <select style={{padding:"3px 8px",fontSize:12,border:"1px solid var(--z-border)",borderRadius:4}} value={mes} onChange={e=>setMes(parseInt(e.target.value))}>
              {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
            </select>
            <input type="number" style={{width:70,padding:"3px 8px",fontSize:12,border:"1px solid var(--z-border)",borderRadius:4}} value={ano} onChange={e=>setAno(parseInt(e.target.value))}/>
            <span className="fs-13">Entradas: <strong className="text-success">R$ {fmt(fluxo.entradas)}</strong></span>
            <span className="fs-13">Saidas: <strong className="text-danger">R$ {fmt(fluxo.saidas)}</strong></span>
            <span style={{fontSize:14,fontWeight:700,color:fluxo.saldo>=0?"var(--z-success-text)":"var(--z-danger-text)"}}>Saldo: R$ {fmt(fluxo.saldo)}</span>
          </div>
        )}

        <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
          {[["pagar","Contas a Pagar"],["receber","Contas a Receber"]].map(([k,l])=>(
            <button key={k} className={"btn btn-secondary"+(aba===k&&abaVis==="lista"?" aba-ativa":"")}
              onClick={()=>{setAba(k);setAbaVis("lista");setFiltroStatus("");}}>
              {l}
            </button>
          ))}
          <button className={"btn btn-secondary"+(abaVis==="calendario"?" aba-ativa":"")} onClick={()=>setAbaVis("calendario")}>
            <i className="ti ti-calendar"/> Calendario
          </button>
        </div>

        {abaVis==="calendario" && <CalendarioFinanceiro contasPagar={contasPagar} contasReceber={contasReceber}/>}

        {abaVis==="lista" && (
          <>
            <div className="page-toolbar">
              <button className="btn btn-primary" onClick={abrirNovo}><i className="ti ti-plus"/> {aba==="pagar"?"Nova Conta a Pagar":"Nova Conta a Receber"}</button>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {Object.entries(STATUS).map(([k,{l}])=>(
                  <button key={k} className={"btn btn-secondary"+(filtroStatus===k?" aba-ativa":"")}
                    style={{fontSize:11,padding:"4px 10px"}} onClick={()=>setFiltroStatus(filtroStatus===k?"":k)}>
                    {l} ({lista.filter(c=>c.status===k).length})
                  </button>
                ))}
              </div>
            </div>
            <div className="card">
              <div className="table-wrapper">
                {loading?<div className="table-empty">Carregando...</div>:
                !filtrada.length?<div className="table-empty">Nenhum lancamento encontrado.</div>:
                <table>
                  <thead><tr>
                    <th>Descricao</th><th>Categoria</th>
                    <th>{aba==="pagar"?"Fornecedor":"Cliente"}</th>
                    <th>Vencimento</th><th className="td-r">Valor</th>
                    <th>Status</th><th></th>
                  </tr></thead>
                  <tbody>
                    {filtrada.map(c=>(
                      <tr key={c.id}>
                        <td><strong>{c.descricao}</strong></td>
                        <td className="fs-12 text-secondary">{c.categoria}</td>
                        <td className="fs-13">{c.fornecedor_nome||c.cliente_nome||"—"}</td>
                        <td style={{fontSize:13,color:c.status==="VENCIDO"?"var(--z-danger-text)":"var(--z-text-secondary)"}}>
                          {new Date(c.data_vencimento+"T12:00:00").toLocaleDateString("pt-BR")}
                        </td>
                        <td style={{textAlign:"right",fontWeight:600}}>R$ {fmt(c.valor)}</td>
                        <td><span style={{color:STATUS[c.status]?.cor,fontWeight:600,fontSize:12}}>{STATUS[c.status]?.l}</span></td>
                        <td style={{textAlign:"right",display:"flex",gap:4}}>
                          {(c.status==="PENDENTE"||c.status==="VENCIDO")&&(
                            <button className="btn btn-primary" style={{fontSize:11,padding:"2px 8px"}}
                              onClick={()=>{setModalPagar(c);setDataPag(hoje);}}>
                              {aba==="pagar"?"Pagar":"Receber"}
                            </button>
                          )}
                          <button className="btn btn-secondary" style={{fontSize:11,padding:"2px 8px"}}
                            onClick={()=>{setForm({...c,fornecedor:c.fornecedor?String(c.fornecedor):"",cliente:c.cliente?String(c.cliente):""});setModalForm("editar");}}>
                            Editar
                          </button>
                          <button className="btn btn-danger" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>excluir(c.id)}>Excluir</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{borderTop:"2px solid var(--z-border)"}}>
                      <td colSpan={4} style={{padding:"8px",textAlign:"right",fontWeight:700}}>
                        Pendente: <span className="text-warning">R$ {fmt(totalPendente)}</span>
                        {totalVencido>0&&<span style={{marginLeft:16,color:"var(--z-danger-text)"}}>Vencido: R$ {fmt(totalVencido)}</span>}
                      </td>
                      <td colSpan={3}></td>
                    </tr>
                  </tfoot>
                </table>}
              </div>
            </div>
          </>
        )}
      </div>

      {modalForm&&(
        <Modal title={modalForm==="novo"?(aba==="pagar"?"Nova Conta a Pagar":"Nova Conta a Receber"):"Editar Conta"}
          onClose={()=>setModalForm(null)} size="md"
          footer={<><button className="btn btn-secondary" onClick={()=>setModalForm(null)}>Cancelar</button><button className="btn btn-primary" onClick={salvarConta} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button></>}>
          <div className="form-grid">
            <div className="form-group" style={{gridColumn:"span 2"}}>
              <label className="form-label">Descricao</label>
              <input className="form-input" value={form.descricao||""} onChange={e=>setF("descricao",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Categoria</label>
              <select className="form-select" value={form.categoria||""} onChange={e=>setF("categoria",e.target.value)}>
                {(aba==="pagar"?CATS_PAGAR:CATS_RECEBER).map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">{aba==="pagar"?"Fornecedor":"Cliente"}</label>
              <select className="form-select" value={form[aba==="pagar"?"fornecedor":"cliente"]||""} onChange={e=>setF(aba==="pagar"?"fornecedor":"cliente",e.target.value)}>
                <option value="">-- Selecione --</option>
                {(aba==="pagar"?fornecedores:clientes).map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Valor (R$)</label>
              <input className="form-input" type="number" value={form.valor||""} onChange={e=>setF("valor",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Data Vencimento</label>
              <input className="form-input" type="date" value={form.data_vencimento||""} onChange={e=>setF("data_vencimento",e.target.value)}/>
            </div>
            <div className="form-group">
              <label className="form-label">Status</label>
              <select className="form-select" value={form.status||""} onChange={e=>setF("status",e.target.value)}>
                {Object.entries(STATUS).map(([v,{l}])=><option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Observacoes</label>
            <textarea className="form-input" rows={2} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/>
          </div>
        </Modal>
      )}

      {modalPagar&&(
        <Modal title={aba==="pagar"?"Confirmar Pagamento":"Confirmar Recebimento"} onClose={()=>setModalPagar(null)} size="sm"
          footer={<><button className="btn btn-secondary" onClick={()=>setModalPagar(null)}>Cancelar</button><button className="btn btn-primary" onClick={confirmarPagamento}>Confirmar</button></>}>
          <div style={{fontSize:14,marginBottom:12}}>
            <strong>{modalPagar.descricao}</strong> — R$ {fmt(modalPagar.valor)}
          </div>
          <div className="form-group">
            <label className="form-label">Data do {aba==="pagar"?"pagamento":"recebimento"}</label>
            <input className="form-input" type="date" value={dataPag} onChange={e=>setDataPag(e.target.value)}/>
          </div>
        </Modal>
      )}
    </>
  );
}